const API_URL = process.env.REACT_APP_SERVER_URL;

export const getPolicy = async () => {
  try {
    const res = await fetch(`${API_URL}/policy/first-pass-rules/current`);
    if (!res.ok) return null;
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching policy:", error);
    return null;
  }
};
